var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.47965C4 6.00561 6.00561 4 8.47965 4H16.2703C18.7444 4 20.75 6.00561 20.75 8.47965V16.2703C20.75 18.7444 18.7444 20.75 16.2703 20.75H8.47965C6.00561 20.75 4 18.7444 4 16.2703V8.47965ZM11.4551 14.0739C11.748 14.3668 12.2229 14.3668 12.5158 14.0739L15.6321 10.9577C15.925 10.6648 15.925 10.1899 15.6321 9.897C15.3392 9.6041 14.8643 9.6041 14.5714 9.897L11.9855 12.4829L10.9577 11.4551C10.6648 11.1622 10.1899 11.1622 9.897 11.4551C9.6041 11.748 9.6041 12.2229 9.897 12.5158L11.4551 14.0739Z",
    fill: "#CAFFD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.c69d578befdeb951b641fb804d5ba78e.svg";
export { ForwardRef as ReactComponent };